/** 环境标量豁免编码及渲染、中心点、GPU 拾取共用的范围判断。 */
export default /* glsl */ `
highp float gsplatScalarFilterExemptValue() {
  // R32F 内部保留负无穷作为环境标记，避免与有限负亮度冲突。
  return uintBitsToFloat(0xff800000u);
}

bool gsplatPassScalarFilter(highp float scalar, highp vec2 range) {
  return scalar == gsplatScalarFilterExemptValue()
    || (scalar >= range.x && scalar <= range.y);
}
`
